var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtreides(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1150 1150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "atreides",
    transform: "matrix(1.68493,0,0,1.68493,-1340,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1137.16,38.561C1305,38.561 1441.27,174.828 1441.27,342.672C1441.27,510.515 1305,646.783 1137.16,646.783C969.312,646.783 833.045,510.515 833.045,342.672C833.045,174.828 969.312,38.561 1137.16,38.561ZM1162.43,252.646C1162.43,252.646 1186.76,240.037 1206.03,213.64C1225.29,187.243 1223.97,180.011 1231.5,180.36C1239.02,180.709 1261.25,179.52 1268.32,195.38C1272.83,205.5 1351.4,478.393 1351.4,478.393C1351.4,478.393 1305.79,464.368 1293.26,458.49C1280.68,452.596 1204.59,359.829 1193.44,350.43C1182.29,341.032 1166.48,343.387 1166.48,343.387L1164.15,376.844L1197.5,423.291L1138.24,504.996L1079.52,423.375L1110.69,377.042L1108.35,342.647C1108.35,342.647 1090.16,340.604 1079.92,350.5C1071.42,358.727 992.449,453.898 983.054,457.301C959.745,465.743 922.906,479.643 922.906,479.643C922.906,479.643 998.025,212.516 1008.65,197.279C1019.28,182.041 1045.65,180.03 1051.47,181.995C1057.29,183.961 1051.69,197.385 1074.65,224.362C1093.95,247.026 1115.35,253.491 1115.35,253.491C1115.35,253.491 1124.19,215.271 1123.11,205.475C1122.33,198.434 1105.27,196.198 1105.27,196.198C1105.27,196.198 1115.52,187.417 1123.86,186.471C1137.09,184.972 1152.1,185.165 1153.78,194.598C1155.43,203.893 1162.43,252.646 1162.43,252.646Z",
    style: {
      fill: "rgb(86,105,45)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtreides);
export default __webpack_public_path__ + "static/media/atreides.fdcb6c76.svg";
export { ForwardRef as ReactComponent };